import axios from '../plugins/axios'

const API_URL = process.env.VUE_APP_API_URL + '/maintenanceconcepts/'
class MaintenanceConceptAPI {
  url = API_URL
  // list(query) {
  //   return axios
  //     .get(API_URL, {
  //       params: query
  //     })
  //     .then(response => {
  //       return response.data
  //     })
  // }
  // show(id) {
  //   return axios
  //     .get(API_URL, {
  //       params: { _id: id }
  //     })
  //     .then(response => {
  //       return response.data[0] || {}
  //     })
  // }
  // edit(id, data) {
  //   return axios
  //     .post(API_URL, {
  //       _id: id,
  //       motorbike: data.motorbike,
  //       date: data.date,
  //       km: data.km,
  //       concept: data.concept,
  //       description: data.description,
  //       price: data.price,
  //       garage: data.garage
  //     })
  //     .then(response => {
  //       return response.data
  //     })
  // }
  // create(data) {
  //   return axios
  //     .post(API_URL, {
  //       motorbike: data.motorbike,
  //       date: data.date,
  //       km: data.km,
  //       concept: data.concept,
  //       description: data.description,
  //       price: data.price,
  //       garage: data.garage
  //     })
  //     .then(response => {
  //       return response.data
  //     })
  // }
  // delete(id) {
  //   return axios
  //     .delete(API_URL + id)
  //     .then(response => {
  //       return response.data
  //     })
  // }
}
export default new MaintenanceConceptAPI()